<template>
  <b-modal 
    :id="id" 
    size="lg" 
    @show="onShow"
    @ok="okHandler" 
    @del="deleteHandler"
  >

    <h3 class="modal-title">{{ title }}</h3>
    <slot></slot>
    
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <button v-if="isFooter" :class="`btn ${okButtonClass}`" @click="ok()">
        {{ okButtonText }}
      </button>
      <button v-if="isDelete && isFooter" :class="`btn ${delButtonClass}`" @click="del()">
        {{ delButtonText }}
      </button>
      <button v-if="isFooter" class="btn btn-outline" @click="cancel()">
        {{ cancelButtonText }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import eventNames from '../../util/eventNames';

export default {
  name: 'BaseModal',
  props: {
    id: {
      type: String,
      default: 'base-modal',
    },
    title: {
      type: String,
      default: 'Modal title',
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isFooter: {
      type: Boolean,
      default: true
    },
    delButtonClass: {
      type: String,
      default: 'btn-warning',
    },
    okButtonClass: {
      type: String,
      default: '',
    },
    okHandler: {
      type: Function,
      default: (bvModalEvt) => {
        console.log('Default function called', bvModalEvt);
      },
    },
    deleteHandler: {
      type: Function,
      default: (bvModalEvt) => {
        console.log('Default function called', bvModalEvt);
      },
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    delButtonText: {
      type: String,
      default: 'Delete recipient',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
    }
  },
  methods: {
    onShow() {
      this.$emit(eventNames.SHOWMODAL);
    },
  },
}
</script>

<style lang="scss">
@import "../../styles/environment/_variables";

#base-modal {
  .modal-title {
    color: $sa-dark-gray;
    font-size: $font-size-mid-header;
    font-weight: $font-main-semibold;
    margin-top: 0;
  }
}

.modal-dialog {
  .modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .modal-title {
    margin-top: 0;
  }

  .modal-body {
    padding-top: 0;
  }

  .modal-footer {
    border-top: none;
    margin-bottom: 20px;
  }
}

.modal-title {
  color: $sa-red-dark;
}

</style>
